import {Injectable} from '@angular/core';
import {ParentService} from "./ParentService";
import {CourseEntity} from "../model/CourseEntity";
import {CourseTypeEntity} from "../model/CourseTypeEntity";
import {ModalityEntity} from "../model/ModalityEntity";
import {TurnEntity} from "../model/TurnEntity";
import {SiteEntity} from "../model/SiteEntity";
import {WorkgroupEntity} from "../model/WorkgroupEntity";
import {TopicEntity} from "../model/TopicEntity";
import {SubjectEntity} from "../model/SubjectEntity";
import {ModuleEntity} from "../model/ModuleEntity";
import {ModuleFolderEntity} from "../model/ModuleFolderEntity";
import {ModuleItemEntity} from "../model/ModuleItemEntity";
import {PackageItemEntity} from "../model/CalendarPackageItem";
import { catchError } from 'rxjs/operators';
import {HttpErrorResponse} from "@angular/common/http";


@Injectable()
export class ModuleService extends ParentService{

  public getModules(corpId) {
    return this.http.get<ModuleEntity[]>(this.shared.MAGNAMENT_URL+'/getModules/'+corpId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveModule(module) {
    return this.http.post<ModuleEntity>(this.shared.MAGNAMENT_URL+'/saveModule', module, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }


  public getModuleFolders(moduleId) {
    return this.http.get<ModuleFolderEntity[]>(this.shared.MAGNAMENT_URL+'/getModuleFolders/'+moduleId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveModuleFolder(moduleFolder) {
    return this.http.post<ModuleFolderEntity>(this.shared.MAGNAMENT_URL+'/saveModuleFolder', moduleFolder, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public deleteModuleFolder(id) {
    return this.http.get(this.shared.MAGNAMENT_URL+'/deleteModuleFolder/'+id, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveModuleFolders(folders) {
    return this.http.post<ModuleFolderEntity[]>(this.shared.MAGNAMENT_URL+'/saveModuleFolders', folders, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }


  public getModuleItems(moduleFolderId) {
    return this.http.get<ModuleItemEntity[]>(this.shared.MAGNAMENT_URL+'/getModuleItems/'+moduleFolderId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveModuleItem(moduleItem) {
    return this.http.post<ModuleItemEntity>(this.shared.MAGNAMENT_URL+'/saveModuleItem', moduleItem, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public deleteModuleItem(id) {
    return this.http.get(this.shared.MAGNAMENT_URL+'/deleteModuleItem/'+id, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveModuleItems(items) {
    return this.http.post<ModuleItemEntity[]>(this.shared.MAGNAMENT_URL+'/saveModuleItems', items, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

}
